<template>
  <div class="change-password">
    <div class="content">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="用户名" prop="username"
          ><span>：</span>
          <el-input v-model="form.username.text" oninput="value=value.replace(/[\u4e00-\u9fa5]/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="原密码" prop="oldPassword"
          ><span>：</span>
          <el-input :type="form.oldPassword.type" v-model="form.oldPassword.text" oninput="value=value.replace(/[\u4e00-\u9fa5]/g, '')">
            <template v-slot:suffix>
              <img :src="form.oldPassword.image" @click="changeShow(1)" class="suffix-image"/>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword"
          ><span>：</span>
          <el-input :type="form.newPassword.type" v-model="form.newPassword.text" oninput="value=value.replace(/[\u4e00-\u9fa5]/g, '')">
            <template v-slot:suffix>
              <img :src="form.newPassword.image" @click="changeShow(2)" class="suffix-image"/>
            </template>
          </el-input>
          <password-strength-bar
            class="password-strength-bar"
            ref="passwordStrengthBar"
            :password="form.newPassword.text"
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword"
          ><span>：</span>
          <el-input :type="form.confirmPassword.type" v-model="form.confirmPassword.text" oninput="value=value.replace(/[\u4e00-\u9fa5]/g, '')">
            <template v-slot:suffix>
              <img :src="form.confirmPassword.image" @click="changeShow(3)" class="suffix-image"/>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import PasswordStrengthBar from '@/components/PasswordStrengthBar.vue'
export default {
  name: 'ChangePasswordWithUsername',
  components: {
    PasswordStrengthBar
  },
  data () {
    return {
      hideImage: require('@/assets/images/userPage/show.png'),
      showImage: require('@/assets/images/userPage/hide.png'),
      form: {
        username: {text: '', type: 'text', image: ''},
        oldPassword: {text: '', type: 'password', image: require('@/assets/images/userPage/hide.png')},
        newPassword: {text: '', type: 'password', image: require('@/assets/images/userPage/hide.png')},
        confirmPassword: {text: '', type: 'password', image: require('@/assets/images/userPage/hide.png')}
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { validator: this.validatePass1, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: this.validatePass2, trigger: 'blur' },
          { validator: this.validatePass2, trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validatePass3, trigger: 'blur' }
        ]
      },
      flag: false,
      flag1: false,
      flag2: false
    }
  },
  methods: {
    changeShow (index) {
      if (index === 1) {
        if (this.form.oldPassword.type === 'password') {
          this.form.oldPassword.type = 'text'
          this.form.oldPassword.image = this.hideImage
        } else {
          this.form.oldPassword.type = 'password'
          this.form.oldPassword.image = this.showImage
        }
      } else if (index === 2) {
        if (this.form.newPassword.type === 'password') {
          this.form.newPassword.type = 'text'
          this.form.newPassword.image = this.hideImage
        } else {
          this.form.newPassword.type = 'password'
          this.form.newPassword.image = this.showImage
        }
      } else if (index === 3) {
        if (this.form.confirmPassword.type === 'password') {
          this.form.confirmPassword.type = 'text'
          this.form.confirmPassword.image = this.hideImage
        } else {
          this.form.confirmPassword.type = 'password'
          this.form.confirmPassword.image = this.showImage
        }
      }
    },
    validatePass1 (rule, value, callback) {
      this.flag1 = false
      if (value.text === '') {
        callback(new Error('请输入原密码！'))
      } else if (value.text.split(" ").join("").length < value.text.length || /[\u4E00-\u9FA5]/g.test(value.text)) {
        callback(new Error('密码中不能含有空格'))
      } else {
        this.flag1 = true
        callback()
      }
    },
    validatePass2 (rule, value, callback) {
      this.flag2 = false
      const checkData = this.$refs.passwordStrengthBar.getCheckPasswordInfo()
      if (!checkData.valid) {
        callback(new Error(checkData.message))
      } else {
        this.flag2 = true
        callback()
      }
    },
    validatePass3 (rule, value, callback) {
      this.flag = false
      if (value.text === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value.text.split(" ").join("").length < value.text.length) {
        callback(new Error('密码中不能含有空格'))
      } else if (value.text !== this.form.newPassword.text) {
        callback(new Error('两次输入密码不一致!'))
      } else if (this.flag1 === true && this.flag2 === true) {
        this.flag = true
        callback()
      }
      // console.log('flag1:', this.flag1,'; flag2:', this.flag2,'; flag:', this.flag)
    }
  }
}
</script>

<style scoped>
.change-password {
  margin-left: 26px;
  margin-right: 26px;
  margin-top: 18px;
}

.change-password >>> .el-form-item__content {
  display: flex;
}

.change-password >>> .el-form-item__label {
  width: 80px;
  text-align: justify;
  text-align-last: justify;
  font-weight: bold;
  color: #634c37;
}

.change-password >>> .el-input__suffix {
  display: flex;
  align-items: center;
}

.change-password >>> .el-input__suffix-inner {
  display: flex;
  align-items: center;
}

.suffix-image {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.password-strength-bar {
  position: absolute;
  width: 90%;
  bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePasswordWithUsername.vue